import { render } from "./CsvUploadZone.vue?vue&type=template&id=2c1a8a8a&scoped=true"
import script from "./CsvUploadZone.vue?vue&type=script&lang=js"
export * from "./CsvUploadZone.vue?vue&type=script&lang=js"

import "./CsvUploadZone.vue?vue&type=style&index=0&id=2c1a8a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1a8a8a"]])

export default __exports__